var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MembersList.jinja');
require('./MembersList.less');
require('./MembersListAvailability.less');

var MembersListInner = require('front/components/MembersList/MembersListInner');

var MembersListTemplate = require('front/components/MembersList/MembersListInnerRuntime.jinja');

var objectFitImages = require('object-fit-images');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MembersList-showMoreButton': 'onClickMoreButton'
    },

    moreApi: function () {
        return this.state.next;
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'MembersListInner': {selector: '.MembersListInner', viewConstructor: MembersListInner}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'moreApi', 'onFilter', 'getUrl');

        this.filterItem = options.filter;

        this.state = {
            limit: {
                featured: parseInt(this.$el.attr('data-limit-featured'), 10),
                searched: parseInt(this.$el.attr('data-limit-searched'), 10)
            },
            next: this.getUrl(),
            hasMore: false
        };

        var isFiltered = $('.MembersListInner').hasClass('MembersListInner--searched');
        var isEmpty = $('.MembersListInner .MembersListInner-empty').length > 0;

        this.$('.MembersList-membersBanner').toggle(isFiltered && !isEmpty);

        window.app.vent.on('Members-filtred', this.onFilter);

        Base.prototype.initialize.call(this, options);
    },


    activate: function () {

        return Base.prototype.activate.call(this);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

    },


    destroy: function () {

        return Base.prototype.destroy.call(this);
    },

    getUrl: function (baseUrl, args) {
        var fields = ['query', 'job', 'domicile', 'skills', 'location', 'hasPortfolio'];

        var values = _.chain(fields).map(function (field) {
            var value = this.filterItem[field] instanceof Array ? this.filterItem[field].join(',') : this.filterItem[field];

            return value && encodeURIComponent(field) + '=' + encodeURIComponent(value);
        }.bind(this))
            .compact()
            .value()
            .concat(args || []);

        //reset alone portfolio parameter
        if (values.length == 1 && this.filterItem.hasPortfolio != undefined) {
            values = [];
        }

        return (baseUrl || Urls['front:members']()) + (values.length ? '?' + values.join('&') : '');
    },

    onFilter: function (filterItem) {
        var self = this;
        var getUrl;
        var isFiltered = $('.MembersListInner').hasClass('MembersListInner--searched');

        this.filterItem = filterItem;

        getUrl = this.getUrl();

        Backbone.history.navigate(getUrl, {trigger: 'true'});

        this.$('.MembersList-showMoreButton')
            .addClass('Button--loading')
            .hide();

        this.$('.MembersListInner').empty();

        this.state.next = this.getUrl(Urls['member:api:search']('json'));

        this.$el.addClass('MembersList--loading');

        this.$searchXhr && this.$searchXhr.abort();

        this.$searchXhr = $.getJSON(this.moreApi(), function (data) {
            var tp = isFiltered ? 'searched' : 'featured';
            var limit = self.state.limit[tp];
            var $list = $(MembersListTemplate.render({data: data, limit: limit, tp: tp, page: 0}));
            self.state.hasMore = data.length > limit;

            self.$('.MembersListInner').empty();
            self.$('.MembersListInner').append($list);

            self.$('.MembersList-membersBanner').toggle(data.length > 0 && isFiltered);

            self.$('.MembersList-showMoreButton')
                .toggle(!!self.state.hasMore)
                .removeClass('Button--loading');

            $(window).resize();

            self.$el.removeClass('MembersList--loading');

            new MembersListInner({
                el: $list[0]
            });

            window.app.utils.updateLinksAttributes(self.$('.MembersList-wrapper'));

            objectFitImages();
        });
    },

    onClickMoreButton: function (e) {
        var self = this;
        var isFiltered = $('.MembersListInner').hasClass('MembersListInner--searched');
        var tp = isFiltered ? 'searched' : 'featured';
        var limit = self.state.limit[tp];

        this.$('.MembersList-showMoreButton').addClass('Button--loading');

        var $hidden = this.$('.MembersListInner-member--hidden');
        var $toShow = $hidden.slice(0, limit);

        $toShow
            .removeClass('MembersListInner-member--hidden')
            .attr('data-animation-state', 'initial')
            .attr('data-animation-accounted', 0);

        // app.animateShowMoreSlideDown({$items: $toShow});

        this.state.hasMore = $hidden.size() > limit;

        $(window).resize();

        self.$('.MembersList-showMoreButton')
            .toggle(!!self.state.hasMore)
            .removeClass('Button--loading');

        window.app.utils.updateLinksAttributes(self.$('.MembersList-wrapper'));

        objectFitImages();
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MembersList/MembersList.js
// module id = 224
// module chunks = 0